import { render, staticRenderFns } from "./apex.vue?vue&type=template&id=1f8d9438&"
import script from "./apex.vue?vue&type=script&lang=js&"
export * from "./apex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports